var request = require('request');
var config = require('./config');

var login = (obj,token) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        timeout: 1500,
        uri: config.URL_BACKEND+'/auth',
        method: 'POST',
        body: obj,
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body: body});
      })
  })
}

var check_auth = (token) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      timeout: 1500,
      uri: config.URL_BACKEND+'/auth/notoken',
      method: 'GET'
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

var logout = (token) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      timeout: 1500,
      uri: config.URL_BACKEND+'/auth/logout',
      method: 'PUT'
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

var esqueci_senha = (body) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 1500,
        uri: config.URL_BACKEND+'/auth/esqueci',
        method: 'PUT',
        body: JSON.stringify(body)
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body: body});
      })
  })
}

module.exports = {
    check_auth:check_auth,
    logout:logout,
    login:login,
    esqueci_senha:esqueci_senha
}